export default "__VITE_ASSET__B_$p4U1c__"